export class MTMACAGroup {
	expanded?: boolean;
	Id: number;
	Name: string;
	Flags?: number;
	SiteId?: number;
	RegistryId?: number;
	WeeklySchedules?: MTMACAWeeklySchedule[];
	SpecialPlannings?: MTMACASpecialPlanning[];
	constructor() {
		this.Id = null;
		this.Name = '';
	}
}

export class MTMACAWeeklySchedule {
	Id?: number;
	Name: string;
	Type: number;
	Weekdays: number;
	DtFrom: string;
	DtTo: string;
	Flags?: number;
	Priority?: number;
	SiteId?: number;
	RegistryId?: number;
	Access?: boolean;
	Old?: boolean;
	// WeekdaysList?: CAWeekDay[];
}

export class MTMACASpecialPlanning {
	Id?: number;
	Name: string;
	Type: number;
	Weekdays?: number;
	DtFrom: string;
	DtTo: string;
	Flags?: number;
	Priority?: number;
	SiteId?: number;
	RegistryId?: number;
	Access?: boolean;
	Old?: boolean;
}

// export class CAWeekDay {
//     Value: string;
//     Name: string;
//     Enable: boolean;
// }

export enum FlagTimeslice {
	DATE_31 = 6,
	DATE_30 = 5,
	DATE_29 = 4,
	REPETITION_ANNUAL = 3,
	REPETITION_MONTHLY = 2,
	TEMPORARY = 1,
	ESCLUDE_INCLUDE = 0
}
